export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// ./src/app/index.ts